export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  AWSDate: { input: string; output: string };
  AWSDateTime: { input: string; output: string };
  AWSEmail: { input: string; output: string };
  AWSIPAddress: { input: string; output: string };
  AWSJSON: { input: string; output: string };
  AWSPhone: { input: string; output: string };
  AWSTime: { input: string; output: string };
  AWSTimestamp: { input: number; output: number };
  AWSURL: { input: string; output: string };
};

export type TAddress = {
  __typename?: 'Address';
  _deleted: Maybe<Scalars['Boolean']['output']>;
  _lastChangedAt: Maybe<Scalars['AWSTimestamp']['output']>;
  _version: Scalars['Int']['output'];
  address1: Maybe<Scalars['String']['output']>;
  address2: Maybe<Scalars['String']['output']>;
  addressFromGoogle: Maybe<TAddressFromGoogle>;
  alert: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  company: Maybe<TCompany>;
  companyId: Scalars['ID']['output'];
  country: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['AWSDateTime']['output']>;
  employee: Maybe<TEmployee>;
  googleValidated: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  invalid: Maybe<Scalars['Boolean']['output']>;
  missingInfo: Maybe<Scalars['Boolean']['output']>;
  office: Maybe<TOffice>;
  parent: Maybe<Scalars['AWSJSON']['output']>;
  parentType: Maybe<TAddressParentTypes>;
  state: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['AWSDateTime']['output']>;
  useGoogleAddress: Maybe<Scalars['Boolean']['output']>;
  zipCode: Maybe<Scalars['String']['output']>;
};

export type TAddressFromGoogle = {
  __typename?: 'AddressFromGoogle';
  address1: Maybe<Scalars['String']['output']>;
  address2: Maybe<Scalars['String']['output']>;
  city: Maybe<Scalars['String']['output']>;
  country: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  zipCode: Maybe<Scalars['String']['output']>;
};

export enum TAddressParentTypes {
  Company = 'company',
  Employee = 'employee',
  Office = 'office'
}

export type TAddressesConnection = {
  __typename?: 'AddressesConnection';
  items: Array<Maybe<TAddress>>;
  nextToken: Maybe<Scalars['String']['output']>;
  scannedCount: Maybe<Scalars['Int']['output']>;
};

export type TAlert = {
  __typename?: 'Alert';
  acknowledgedAt: Maybe<Scalars['AWSDateTime']['output']>;
  acknowledgedBy: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['AWSDateTime']['output']>;
  message: Scalars['String']['output'];
  newItem: Maybe<Scalars['AWSJSON']['output']>;
  oldItem: Maybe<Scalars['AWSJSON']['output']>;
};

export type TAlertInput = {
  acknowledgedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  acknowledgedBy?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  newItem?: InputMaybe<Scalars['AWSJSON']['input']>;
  oldItem?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export enum TCarriers {
  CanadaPost = 'canada_post',
  DhlExpressCanada = 'dhl_express_canada',
  PurolatorCa = 'purolator_ca',
  Ups = 'ups'
}

export type TCompaniesConnection = {
  __typename?: 'CompaniesConnection';
  items: Array<Maybe<TCompany>>;
  nextToken: Maybe<Scalars['String']['output']>;
  scannedCount: Maybe<Scalars['Int']['output']>;
};

export type TCompany = {
  __typename?: 'Company';
  _deleted: Maybe<Scalars['Boolean']['output']>;
  _lastChangedAt: Maybe<Scalars['AWSTimestamp']['output']>;
  _version: Scalars['Int']['output'];
  accountManager: Maybe<Scalars['String']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  address: Maybe<TAddress>;
  bambooHRAPIKey: Maybe<Scalars['String']['output']>;
  bambooHRPetsTableName: Maybe<Scalars['String']['output']>;
  bambooHRSubdomain: Maybe<Scalars['String']['output']>;
  childBirthdayActivated: Scalars['Boolean']['output'];
  companyWideLegoCustomization: Maybe<Scalars['String']['output']>;
  configuration: Maybe<TConfigurationType>;
  contact: Maybe<TContact>;
  createdAt: Maybe<Scalars['AWSDateTime']['output']>;
  customLego: Maybe<Scalars['Boolean']['output']>;
  customShippingConfiguration: Maybe<Array<Maybe<TCustomShippingConfigurationType>>>;
  customWorkAnniversaryNotes: Maybe<Scalars['String']['output']>;
  deliveryMethod: TDeliveryMethod;
  emailDomains: Array<Scalars['String']['output']>;
  employeeBirthdayActivated: Scalars['Boolean']['output'];
  employeeCount: Maybe<Scalars['Int']['output']>;
  employeeNewHireKitActivated: Scalars['Boolean']['output'];
  employeeWorkAnniversaryActivated: Scalars['Boolean']['output'];
  employees: TEmployeesConnection;
  endDate: Maybe<Scalars['AWSDate']['output']>;
  fullyConfigured: Maybe<Scalars['Boolean']['output']>;
  giftPacks: Maybe<Scalars['AWSJSON']['output']>;
  googleLoginEnabled: Maybe<Scalars['Boolean']['output']>;
  hasCustomOnboardBrick: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  importFromBambooHR: Scalars['Boolean']['output'];
  isLive: Maybe<Scalars['Boolean']['output']>;
  lastRosterUpload: Maybe<Scalars['AWSDateTime']['output']>;
  legoActivated: Maybe<Scalars['Boolean']['output']>;
  legoColor: Maybe<Scalars['String']['output']>;
  logo: Maybe<Scalars['AWSURL']['output']>;
  name: Scalars['String']['output'];
  normalizedName: Maybe<Scalars['String']['output']>;
  offices: TOfficesConnection;
  oldSystemId: Maybe<Scalars['Int']['output']>;
  passwordLoginEnabled: Maybe<Scalars['Boolean']['output']>;
  petBirthdayActivated: Scalars['Boolean']['output'];
  rosterId: Maybe<Scalars['String']['output']>;
  signAs: Maybe<Scalars['String']['output']>;
  significantOtherBirthdayActivated: Scalars['Boolean']['output'];
  specialNote: Maybe<Scalars['String']['output']>;
  spreadsheetId: Maybe<Scalars['String']['output']>;
  startDate: Maybe<Scalars['AWSDate']['output']>;
  subdomain: Scalars['String']['output'];
  subscriptionPriceCurrency: Maybe<Scalars['String']['output']>;
  subscriptionPricePerUser: Maybe<Scalars['Float']['output']>;
  swag: Maybe<Scalars['String']['output']>;
  tissueColor: Scalars['String']['output'];
  updatedAt: Maybe<Scalars['AWSDateTime']['output']>;
  userPoolId: Maybe<Scalars['String']['output']>;
  users: TUsersConnection;
  workAnniversaryGiftVariation: Maybe<TWorkAnniversaryGiftVariations>;
};

export type TCompanyEmployeesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TCompanyOfficesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TCompanyUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TConfigurationType = {
  __typename?: 'ConfigurationType';
  authCloudfrontDomain: Maybe<Scalars['String']['output']>;
  authUserPoolClientId: Maybe<Scalars['String']['output']>;
  authUserPoolClientName: Maybe<Scalars['String']['output']>;
  authUserPoolDomainURL: Maybe<Scalars['String']['output']>;
  authUserPoolId: Maybe<Scalars['String']['output']>;
  authUserPoolName: Maybe<Scalars['String']['output']>;
  frontendCertificateArn: Maybe<Scalars['String']['output']>;
  frontendDistributionArn: Maybe<Scalars['String']['output']>;
  frontendDistributionDomainName: Maybe<Scalars['String']['output']>;
  frontendDistributionId: Maybe<Scalars['String']['output']>;
};

export type TContact = {
  __typename?: 'Contact';
  email: Maybe<Scalars['AWSEmail']['output']>;
  name: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
};

export type TCreateAddressMutationInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  useGoogleAddress?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type TCreateCompanyMutationInput = {
  accountManager?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<TCreateAddressMutationInput>;
  bambooHRAPIKey?: InputMaybe<Scalars['String']['input']>;
  bambooHRPetsTableName?: InputMaybe<Scalars['String']['input']>;
  bambooHRSubdomain?: InputMaybe<Scalars['String']['input']>;
  childBirthdayActivated?: InputMaybe<Scalars['Boolean']['input']>;
  companyWideLegoCustomization?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<TCreateContactMutationInput>;
  customLego?: InputMaybe<Scalars['Boolean']['input']>;
  customShippingConfiguration?: InputMaybe<Array<InputMaybe<TCustomShippingConfigurationInput>>>;
  customWorkAnniversaryNotes?: InputMaybe<Scalars['String']['input']>;
  deliveryMethod: TDeliveryMethod;
  emailDomains: Array<Scalars['String']['input']>;
  employeeBirthdayActivated?: InputMaybe<Scalars['Boolean']['input']>;
  employeeNewHireKitActivated?: InputMaybe<Scalars['Boolean']['input']>;
  employeeWorkAnniversaryActivated?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['AWSDate']['input']>;
  googleLoginEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  hasCustomOnboardBrick?: InputMaybe<Scalars['Boolean']['input']>;
  importFromBambooHR?: InputMaybe<Scalars['Boolean']['input']>;
  isLive?: InputMaybe<Scalars['Boolean']['input']>;
  legoActivated?: InputMaybe<Scalars['Boolean']['input']>;
  legoColor?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['AWSURL']['input']>;
  name: Scalars['String']['input'];
  oldSystemId?: InputMaybe<Scalars['Int']['input']>;
  passwordLoginEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  petBirthdayActivated?: InputMaybe<Scalars['Boolean']['input']>;
  rosterId?: InputMaybe<Scalars['String']['input']>;
  signAs?: InputMaybe<Scalars['String']['input']>;
  significantOtherBirthdayActivated?: InputMaybe<Scalars['Boolean']['input']>;
  specialNote?: InputMaybe<Scalars['String']['input']>;
  spreadsheetId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['AWSDate']['input']>;
  subdomain: Scalars['String']['input'];
  subscriptionPriceCurrency?: InputMaybe<Scalars['String']['input']>;
  subscriptionPricePerUser?: InputMaybe<Scalars['Float']['input']>;
  swag?: InputMaybe<Scalars['String']['input']>;
  tissueColor: Scalars['String']['input'];
  workAnniversaryGiftVariation?: InputMaybe<TWorkAnniversaryGiftVariations>;
};

export type TCreateContactMutationInput = {
  email?: InputMaybe<Scalars['AWSEmail']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TCreateDependantMutationInput = {
  birthDate?: InputMaybe<Scalars['AWSDate']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  donateBirthdayGift?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  foodPreferences?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  oldSystemId?: InputMaybe<Scalars['Int']['input']>;
  petType?: InputMaybe<Scalars['String']['input']>;
  preferredFirstName?: InputMaybe<Scalars['String']['input']>;
  type: TDependantType;
};

export type TCreateEmployeeMutationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<TCreateAddressMutationInput>;
  birthDate?: InputMaybe<Scalars['AWSDate']['input']>;
  companyId: Scalars['ID']['input'];
  customOnboardBrick?: InputMaybe<Scalars['String']['input']>;
  deliveryMethod?: InputMaybe<TDeliveryMethod>;
  dependants?: InputMaybe<Array<InputMaybe<TCreateDependantMutationInput>>>;
  donateBirthdayGift?: InputMaybe<Scalars['Boolean']['input']>;
  donateWorkAnniversaryGift?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['AWSEmail']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  foodPreferences?: InputMaybe<Scalars['String']['input']>;
  giftOnHoldFrom?: InputMaybe<Scalars['AWSDate']['input']>;
  giftOnHoldTo?: InputMaybe<Scalars['AWSDate']['input']>;
  giftPausedFrom?: InputMaybe<Scalars['AWSDate']['input']>;
  giftPausedTo?: InputMaybe<Scalars['AWSDate']['input']>;
  hireDate?: InputMaybe<Scalars['AWSDate']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  officeId?: InputMaybe<Scalars['ID']['input']>;
  oldSystemId?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferredFirstName?: InputMaybe<Scalars['String']['input']>;
  sweaterSize?: InputMaybe<Scalars['String']['input']>;
  tShirtSize?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TCreateEventGiftResponse = {
  __typename?: 'CreateEventGiftResponse';
  companyId: Scalars['ID']['output'];
  event: Maybe<TEvent>;
  gift: Maybe<TGift>;
};

export type TCreateEventMutationInput = {
  addressId?: InputMaybe<Scalars['ID']['input']>;
  age: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  customType?: InputMaybe<Scalars['String']['input']>;
  deliveredAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  employeeId: Scalars['ID']['input'];
  eventDate: Scalars['AWSDate']['input'];
  giftId?: InputMaybe<Scalars['ID']['input']>;
  groupedToEventId?: InputMaybe<Scalars['ID']['input']>;
  isPaused?: InputMaybe<Scalars['Boolean']['input']>;
  recipientId: Scalars['ID']['input'];
  referenceEventId?: InputMaybe<Scalars['ID']['input']>;
  skippedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  type: TEventTypes;
  wasPaused?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TCreateGiftMutationInput = {
  addressId?: InputMaybe<Scalars['ID']['input']>;
  companyId: Scalars['ID']['input'];
  customType?: InputMaybe<Scalars['String']['input']>;
  doneAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  employeeId: Scalars['ID']['input'];
  eventDate: Scalars['AWSDate']['input'];
  eventId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  oldSystemId?: InputMaybe<Scalars['Int']['input']>;
  rack?: InputMaybe<Scalars['String']['input']>;
  recipientId: Scalars['ID']['input'];
  recreatedFromId?: InputMaybe<Scalars['ID']['input']>;
  referenceEventDate?: InputMaybe<Scalars['AWSDate']['input']>;
  shipmentId?: InputMaybe<Scalars['ID']['input']>;
  shippingDate?: InputMaybe<Scalars['AWSDate']['input']>;
  status?: InputMaybe<TGiftStatuses>;
  type: TGiftTypes;
};

export type TCreateGiftPackageMutationInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  isDefault?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  products: Array<InputMaybe<Scalars['String']['input']>>;
  subType?: InputMaybe<Scalars['String']['input']>;
  type: TGiftPackageType;
};

export type TCreateOfficeMutationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<TCreateAddressMutationInput>;
  companyId: Scalars['ID']['input'];
  contact?: InputMaybe<TCreateContactMutationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  oldSystemId?: InputMaybe<Scalars['Int']['input']>;
};

export type TCreateProductMutationInput = {
  country: Scalars['String']['input'];
  description: Scalars['String']['input'];
  hsCode: Scalars['String']['input'];
  manufacturerNsProductId?: InputMaybe<Scalars['String']['input']>;
  manufacturerProductId?: InputMaybe<Scalars['String']['input']>;
  manufacturerProductIdType?: InputMaybe<TManufacturerProductIdType>;
  originCriterion?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Float']['input'];
};

export type TCreateReferenceEventMutationInput = {
  addressId?: InputMaybe<Scalars['ID']['input']>;
  companyId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
  fullDate: Scalars['AWSDate']['input'];
  recipientId: Scalars['ID']['input'];
  type: TReferenceEventTypes;
};

export type TCreateRosterFileInput = {
  changelog?: InputMaybe<Scalars['AWSJSON']['input']>;
  changelogFile?: InputMaybe<TCreateRosterFileS3ObjectInput>;
  companyId: Scalars['ID']['input'];
  file?: InputMaybe<TCreateRosterFileS3ObjectInput>;
  headerMapping?: InputMaybe<Scalars['AWSJSON']['input']>;
  mapping: Scalars['AWSJSON']['input'];
  officeMapping?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type TCreateRosterFileS3ObjectInput = {
  bucket: Scalars['String']['input'];
  key: Scalars['String']['input'];
  region: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

export type TCreateShipmentMutationInput = {
  addressId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
  customsData?: InputMaybe<Array<InputMaybe<TCustomsDataInput>>>;
  label?: InputMaybe<TShipmentLabelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  oldSystemId?: InputMaybe<Scalars['Int']['input']>;
  packageInfo?: InputMaybe<TPackageInfoInput>;
  rack?: InputMaybe<Scalars['String']['input']>;
  shippingDate?: InputMaybe<Scalars['AWSDate']['input']>;
  status: TShipmentStatuses;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TCreateShipmentWithGiftsMutationInput = {
  addressId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
  customsData?: InputMaybe<Array<InputMaybe<TCustomsDataInput>>>;
  giftsIds: Array<Scalars['ID']['input']>;
  label?: InputMaybe<TShipmentLabelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  oldSystemId?: InputMaybe<Scalars['Int']['input']>;
  packageInfo?: InputMaybe<TPackageInfoInput>;
  rack?: InputMaybe<Scalars['String']['input']>;
  shippingDate?: InputMaybe<Scalars['AWSDate']['input']>;
  status?: InputMaybe<TShipmentStatuses>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TCreateUserMutationInput = {
  companyId: Scalars['ID']['input'];
  email: Scalars['AWSEmail']['input'];
  name: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  type: TUserType;
};

export enum TCustomReportEntity {
  Events = 'events',
  Gifts = 'gifts',
  Shipments = 'shipments'
}

/** One UTC month by eventDate for Events and createdAt for Gifts/Shipments. Empty selections include all values. Company and address filters use current data. */
export type TCustomReportInput = {
  companyActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restricts every record, including birthdays, by the company's current anniversary edition. */
  companyGiftVariations?: InputMaybe<Array<TWorkAnniversaryGiftVariations>>;
  companyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  entity: TCustomReportEntity;
  /** Events only: whether deliveredAt is set. */
  eventDelivered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Events only: whether giftId is set. */
  eventHasGift?: InputMaybe<Scalars['Boolean']['input']>;
  eventPaused?: InputMaybe<Scalars['Boolean']['input']>;
  /** Events only. Defaults to existing. Expected projects recurring events without writes, up to two years ahead. */
  eventReportType?: InputMaybe<TEventReportType>;
  eventSkipped?: InputMaybe<Scalars['Boolean']['input']>;
  /** Events only: matches the event's own type. */
  eventTypes?: InputMaybe<Array<TEventTypes>>;
  /** Expected Events only. Defaults to true. Set false to include paused employees and their dependants. */
  excludePausedEmployees?: InputMaybe<Scalars['Boolean']['input']>;
  /** Gifts only: whether shipmentId is set. */
  giftHasShipment?: InputMaybe<Scalars['Boolean']['input']>;
  giftStatuses?: InputMaybe<Array<TGiftStatuses>>;
  /** Gifts: matches the gift's type. Shipments: matches at least one attached gift. */
  giftTypes?: InputMaybe<Array<TGiftTypes>>;
  month: Scalars['String']['input'];
  /** Shipments only: matches addressVerified. */
  shipmentAddressVerification?: InputMaybe<Array<TShipStationAddressVerified>>;
  /** Shipments only: matches label.carrier. */
  shipmentCarriers?: InputMaybe<Array<TCarriers>>;
  shipmentStatuses?: InputMaybe<Array<TShipmentStatuses>>;
  /** Restricts work anniversaries only; other types remain eligible. */
  workAnniversaryVariations?: InputMaybe<Array<TWorkAnniversaryGiftVariations>>;
};

/** Matching record counts per company for the selected month. */
export type TCustomReportRow = {
  __typename?: 'CustomReportRow';
  companyId: Scalars['ID']['output'];
  companyName: Scalars['String']['output'];
  count: Scalars['Int']['output'];
};

export type TCustomShippingConfigurationInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  carrier?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  overrideInternationalOnly?: InputMaybe<Scalars['Boolean']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

export type TCustomShippingConfigurationType = {
  __typename?: 'CustomShippingConfigurationType';
  accountNumber: Maybe<Scalars['String']['output']>;
  carrier: Maybe<Scalars['String']['output']>;
  countryCode: Maybe<Scalars['String']['output']>;
  overrideInternationalOnly: Maybe<Scalars['Boolean']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
};

export type TCustomsData = {
  __typename?: 'CustomsData';
  country: Scalars['String']['output'];
  description: Scalars['String']['output'];
  hsCode: Scalars['String']['output'];
  manufacturerNsProductId: Maybe<Scalars['String']['output']>;
  manufacturerProductId: Maybe<Scalars['String']['output']>;
  manufacturerProductIdType: Maybe<TManufacturerProductIdType>;
  originCriterion: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  sku: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};

export type TCustomsDataInput = {
  country: Scalars['String']['input'];
  description: Scalars['String']['input'];
  hsCode: Scalars['String']['input'];
  manufacturerNsProductId?: InputMaybe<Scalars['String']['input']>;
  manufacturerProductId?: InputMaybe<Scalars['String']['input']>;
  manufacturerProductIdType?: InputMaybe<TManufacturerProductIdType>;
  originCriterion?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  sku?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Float']['input'];
};

export enum TDeliveryMethod {
  Default = 'default',
  Home = 'home',
  Hybrid = 'hybrid',
  Office = 'office'
}

export type TDependant = TRecipient & {
  __typename?: 'Dependant';
  _deleted: Maybe<Scalars['Boolean']['output']>;
  _lastChangedAt: Maybe<Scalars['AWSTimestamp']['output']>;
  _version: Maybe<Scalars['Int']['output']>;
  address: Maybe<TAddress>;
  birthDate: Maybe<Scalars['AWSDate']['output']>;
  company: Maybe<TCompany>;
  companyId: Scalars['ID']['output'];
  createdAt: Maybe<Scalars['AWSDateTime']['output']>;
  donateBirthdayGift: Maybe<Scalars['Boolean']['output']>;
  employee: Maybe<TEmployee>;
  employeeId: Scalars['ID']['output'];
  events: TEventsConnection;
  firstName: Maybe<Scalars['String']['output']>;
  foodPreferences: Maybe<Scalars['String']['output']>;
  fullName: Maybe<Scalars['String']['output']>;
  gifts: TGiftsConnection;
  id: Scalars['ID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  oldSystemId: Maybe<Scalars['Int']['output']>;
  petType: Maybe<Scalars['String']['output']>;
  preferredFirstName: Maybe<Scalars['String']['output']>;
  type: TDependantType;
  updatedAt: Maybe<Scalars['AWSDateTime']['output']>;
};

export type TDependantEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TDependantGiftsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export enum TDependantType {
  Child = 'child',
  Pet = 'pet',
  SignificantOther = 'significantOther'
}

export type TDependantsConnection = {
  __typename?: 'DependantsConnection';
  items: Array<Maybe<TDependant>>;
  nextToken: Maybe<Scalars['String']['output']>;
  scannedCount: Maybe<Scalars['Int']['output']>;
};

export type TEmployee = TRecipient & {
  __typename?: 'Employee';
  _deleted: Maybe<Scalars['Boolean']['output']>;
  _lastChangedAt: Maybe<Scalars['AWSTimestamp']['output']>;
  _version: Maybe<Scalars['Int']['output']>;
  active: Maybe<Scalars['Boolean']['output']>;
  address: Maybe<TAddress>;
  birthDate: Maybe<Scalars['AWSDate']['output']>;
  company: Maybe<TCompany>;
  companyId: Scalars['ID']['output'];
  createdAt: Maybe<Scalars['AWSDateTime']['output']>;
  customOnboardBrick: Maybe<Scalars['String']['output']>;
  deliveryMethod: Maybe<TDeliveryMethod>;
  dependants: TDependantsConnection;
  donateBirthdayGift: Maybe<Scalars['Boolean']['output']>;
  donateWorkAnniversaryGift: Maybe<Scalars['Boolean']['output']>;
  email: Maybe<Scalars['AWSEmail']['output']>;
  events: TEventsConnection;
  externalId: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  foodPreferences: Maybe<Scalars['String']['output']>;
  fullName: Maybe<Scalars['String']['output']>;
  gifts: TGiftsConnection;
  hireDate: Maybe<Scalars['AWSDate']['output']>;
  id: Scalars['ID']['output'];
  isPaused: Maybe<Scalars['Boolean']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  office: Maybe<TOffice>;
  officeId: Maybe<Scalars['ID']['output']>;
  oldSystemId: Maybe<Scalars['Int']['output']>;
  oldSystemIds: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  organization: Maybe<Scalars['String']['output']>;
  pausePeriod: Maybe<TPausePeriod>;
  pausePeriods: Maybe<Array<Maybe<TPausePeriod>>>;
  phoneNumber: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  preferredFirstName: Maybe<Scalars['String']['output']>;
  sweaterSize: Maybe<Scalars['String']['output']>;
  tShirtSize: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['AWSDateTime']['output']>;
};

export type TEmployeeDependantsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TEmployeeEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TEmployeeGiftsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TEmployeesConnection = {
  __typename?: 'EmployeesConnection';
  items: Array<Maybe<TEmployee>>;
  nextToken: Maybe<Scalars['String']['output']>;
  scannedCount: Maybe<Scalars['Int']['output']>;
};

export type TEvent = {
  __typename?: 'Event';
  _deleted: Maybe<Scalars['Boolean']['output']>;
  _lastChangedAt: Maybe<Scalars['AWSTimestamp']['output']>;
  _version: Scalars['Int']['output'];
  address: Maybe<TAddress>;
  addressId: Maybe<Scalars['ID']['output']>;
  age: Maybe<Scalars['Int']['output']>;
  brickColor: Maybe<Scalars['String']['output']>;
  brickQuantity: Maybe<Scalars['Int']['output']>;
  brickSize: Maybe<Scalars['String']['output']>;
  brickText: Maybe<Scalars['String']['output']>;
  company: Maybe<TCompany>;
  companyId: Scalars['ID']['output'];
  createdAt: Maybe<Scalars['AWSDateTime']['output']>;
  customType: Maybe<Scalars['String']['output']>;
  deliveredAt: Maybe<Scalars['AWSDateTime']['output']>;
  employee: Maybe<TEmployee>;
  employeeId: Scalars['ID']['output'];
  eventDate: Scalars['AWSDate']['output'];
  gift: Maybe<TGift>;
  giftId: Maybe<Scalars['ID']['output']>;
  groupedToEvent: Maybe<TEvent>;
  groupedToEventId: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  isPaused: Maybe<Scalars['Boolean']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  oneOffSource: Maybe<Scalars['String']['output']>;
  recipient: Maybe<TRecipient>;
  recipientId: Scalars['ID']['output'];
  referenceEvent: Maybe<TReferenceEvent>;
  referenceEventId: Maybe<Scalars['ID']['output']>;
  shippingDate: Maybe<Scalars['AWSDate']['output']>;
  skippedAt: Maybe<Scalars['AWSDateTime']['output']>;
  subRows: Maybe<Scalars['AWSJSON']['output']>;
  type: TEventTypes;
  updatedAt: Maybe<Scalars['AWSDateTime']['output']>;
  wasPaused: Maybe<Scalars['Boolean']['output']>;
};

export enum TEventReportType {
  Existing = 'existing',
  Expected = 'expected'
}

export enum TEventTypes {
  BabyGift = 'babyGift',
  Bereavement = 'bereavement',
  Birthday = 'birthday',
  CarePackage = 'carePackage',
  CustomBricks = 'customBricks',
  NewHire = 'newHire',
  Other = 'other',
  ReplacementEmployeeBirthday = 'replacementEmployeeBirthday',
  ReplacementWorkAnniversary = 'replacementWorkAnniversary',
  Wedding = 'wedding',
  WorkAnniversary = 'workAnniversary'
}

export type TEventsConnection = {
  __typename?: 'EventsConnection';
  items: Array<Maybe<TEvent>>;
  nextToken: Maybe<Scalars['String']['output']>;
  scannedCount: Maybe<Scalars['Int']['output']>;
};

export type TEventsReportRow = {
  __typename?: 'EventsReportRow';
  companyId: Scalars['ID']['output'];
  companyName: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  eventType: Scalars['String']['output'];
};

export type TFilterInput = {
  ExpressionAttributeNames: Array<InputMaybe<TInputFiltering>>;
  ExpressionAttributeValues: Array<InputMaybe<TInputFiltering>>;
  FilterExpression: Scalars['String']['input'];
};

export type TFinancialReportRow = {
  __typename?: 'FinancialReportRow';
  actual: Maybe<Scalars['Int']['output']>;
  clientCost: Maybe<Scalars['Float']['output']>;
  companyId: Scalars['ID']['output'];
  companyName: Scalars['String']['output'];
  forecast: Maybe<Scalars['Int']['output']>;
  gifts: Maybe<Scalars['Int']['output']>;
  previousYear: Scalars['Int']['output'];
  shipmentCost: Maybe<Scalars['Float']['output']>;
};

export type TGift = {
  __typename?: 'Gift';
  _deleted: Maybe<Scalars['Boolean']['output']>;
  _lastChangedAt: Maybe<Scalars['AWSTimestamp']['output']>;
  _version: Scalars['Int']['output'];
  address: Maybe<TAddress>;
  addressId: Maybe<Scalars['ID']['output']>;
  alerts: Maybe<Array<Maybe<TAlert>>>;
  brickColor: Maybe<Scalars['String']['output']>;
  brickQuantity: Maybe<Scalars['Int']['output']>;
  brickSize: Maybe<Scalars['String']['output']>;
  brickText: Maybe<Scalars['String']['output']>;
  company: Maybe<TCompany>;
  companyId: Scalars['ID']['output'];
  createdAt: Maybe<Scalars['AWSDateTime']['output']>;
  customType: Maybe<Scalars['String']['output']>;
  doneAt: Maybe<Scalars['AWSDateTime']['output']>;
  employee: Maybe<TEmployee>;
  employeeId: Scalars['ID']['output'];
  event: Maybe<TEvent>;
  eventDate: Scalars['AWSDate']['output'];
  eventId: Scalars['ID']['output'];
  group: Maybe<Scalars['String']['output']>;
  groupedGifts: Maybe<Scalars['AWSJSON']['output']>;
  id: Scalars['ID']['output'];
  isDone: Maybe<Scalars['Int']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  oldSystemId: Maybe<Scalars['Int']['output']>;
  oneOffSource: Maybe<Scalars['String']['output']>;
  rack: Maybe<Scalars['String']['output']>;
  recipient: Maybe<TRecipient>;
  recipientData: Maybe<Scalars['AWSJSON']['output']>;
  recipientId: Scalars['ID']['output'];
  recreatedFromId: Maybe<Scalars['ID']['output']>;
  referenceEventDate: Maybe<Scalars['AWSDate']['output']>;
  shipment: Maybe<TShipment>;
  shipmentId: Maybe<Scalars['ID']['output']>;
  shippingDate: Maybe<Scalars['AWSDate']['output']>;
  status: TGiftStatuses;
  status_IsDone_ShipmentId: Maybe<Scalars['Int']['output']>;
  type: TGiftTypes;
  type_status_IsDone_ShipmentId: Maybe<Scalars['Int']['output']>;
  updatedAt: Maybe<Scalars['AWSDateTime']['output']>;
};

export type TGiftPackage = {
  __typename?: 'GiftPackage';
  _deleted: Maybe<Scalars['Boolean']['output']>;
  _lastChangedAt: Maybe<Scalars['AWSTimestamp']['output']>;
  _version: Scalars['Int']['output'];
  company: Maybe<TCompany>;
  companyId: Maybe<Scalars['ID']['output']>;
  createdAt: Maybe<Scalars['AWSDateTime']['output']>;
  hydratedProducts: Maybe<Scalars['AWSJSON']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  products: Array<Maybe<Scalars['String']['output']>>;
  subType: Maybe<Scalars['String']['output']>;
  type: TGiftPackageType;
  updatedAt: Maybe<Scalars['AWSDateTime']['output']>;
};

export type TGiftPackageConnection = {
  __typename?: 'GiftPackageConnection';
  items: Array<Maybe<TGiftPackage>>;
  nextToken: Maybe<Scalars['String']['output']>;
  scannedCount: Maybe<Scalars['Int']['output']>;
};

export enum TGiftPackageType {
  ChildBirthday = 'childBirthday',
  EmployeeBirthday = 'employeeBirthday',
  NewHire = 'newHire',
  OneOff = 'oneOff',
  PetBirthday = 'petBirthday',
  SpouseBirthday = 'spouseBirthday',
  WorkAnniversary = 'workAnniversary'
}

export enum TGiftStatuses {
  Assembling = 'assembling',
  Done = 'done',
  Qa = 'qa',
  Todo = 'todo'
}

export enum TGiftTypes {
  BabyGift = 'babyGift',
  Bereavement = 'bereavement',
  Birthday = 'birthday',
  CarePackage = 'carePackage',
  CustomBricks = 'customBricks',
  NewHire = 'newHire',
  Other = 'other',
  ReplacementEmployeeBirthday = 'replacementEmployeeBirthday',
  ReplacementWorkAnniversary = 'replacementWorkAnniversary',
  Wedding = 'wedding',
  WorkAnniversary = 'workAnniversary'
}

export type TGiftsConnection = {
  __typename?: 'GiftsConnection';
  items: Array<Maybe<TGift>>;
  nextToken: Maybe<Scalars['String']['output']>;
  scannedCount: Maybe<Scalars['Int']['output']>;
};

export type TGiftsReportRow = {
  __typename?: 'GiftsReportRow';
  babyGift: Scalars['Int']['output'];
  bereavement: Scalars['Int']['output'];
  carePackage: Scalars['Int']['output'];
  companyId: Scalars['ID']['output'];
  companyName: Scalars['String']['output'];
  customBricks: Scalars['Int']['output'];
  dependantBirthday: Scalars['Int']['output'];
  employeeBirthday: Scalars['Int']['output'];
  isTotal: Scalars['Boolean']['output'];
  newHire: Scalars['Int']['output'];
  other: Scalars['Int']['output'];
  replacementEmployeeBirthday: Scalars['Int']['output'];
  replacementWorkAnniversary: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  wedding: Scalars['Int']['output'];
  workAnniversaryBrickOnly: Scalars['Int']['output'];
  workAnniversaryCustom: Scalars['Int']['output'];
  workAnniversaryDeluxe: Scalars['Int']['output'];
  workAnniversaryLegoOnly: Scalars['Int']['output'];
  workAnniversaryMini: Scalars['Int']['output'];
};

export type TInputFiltering = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type TLambdaConnection = {
  __typename?: 'LambdaConnection';
  data: Maybe<Scalars['AWSJSON']['output']>;
  error: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  status: Scalars['Int']['output'];
};

export type TLog = {
  __typename?: 'Log';
  action: Maybe<Scalars['String']['output']>;
  arguments: Maybe<Scalars['AWSJSON']['output']>;
  company: Maybe<TCompany>;
  companyId: Maybe<Scalars['ID']['output']>;
  employee: Maybe<TEmployee>;
  entity: Maybe<Scalars['String']['output']>;
  fieldName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identity: Maybe<Scalars['AWSJSON']['output']>;
  identityUserEmail: Maybe<Scalars['String']['output']>;
  identityUserName: Maybe<Scalars['String']['output']>;
  occurredAt: Maybe<Scalars['AWSDateTime']['output']>;
  parentTypeName: Maybe<Scalars['String']['output']>;
  resourceId: Maybe<Scalars['ID']['output']>;
  response: Maybe<Scalars['AWSJSON']['output']>;
  selectionSetGraphQL: Maybe<Scalars['String']['output']>;
  type: Maybe<Scalars['String']['output']>;
  userId: Maybe<Scalars['ID']['output']>;
  userType: Maybe<TLogUserTypes>;
  variables: Maybe<Scalars['AWSJSON']['output']>;
};

export enum TLogUserTypes {
  Client = 'client',
  Internal = 'internal',
  System = 'system'
}

export type TLogsConnection = {
  __typename?: 'LogsConnection';
  items: Array<Maybe<TLog>>;
  nextToken: Maybe<Scalars['String']['output']>;
  scannedCount: Maybe<Scalars['Int']['output']>;
};

export enum TManufacturerProductIdType {
  Ean = 'ean',
  Gtin = 'gtin',
  Isbn = 'isbn',
  Mpn = 'mpn',
  Sku = 'sku',
  Undefined = 'undefined',
  Upc = 'upc'
}

export type TMoveGiftMutationInput = {
  status: TGiftStatuses;
};

export type TMoveShipmentMutationInput = {
  status: TShipmentStatuses;
};

export type TMutation = {
  __typename?: 'Mutation';
  addAlertToGift: Maybe<TGift>;
  addAlertToShipment: Maybe<TShipment>;
  addGiftsToShipment: Maybe<TShipment>;
  cancelShipmentForPickup: Maybe<TShipment>;
  createCSUser: Maybe<TUser>;
  createCompany: Maybe<TCompany>;
  createDependant: Maybe<TDependant>;
  createEmployee: Maybe<TEmployee>;
  createEvent: Maybe<TEvent>;
  createEventGift: Maybe<TCreateEventGiftResponse>;
  createGift: Maybe<TGift>;
  createGiftPackage: Maybe<TGiftPackage>;
  createOffice: Maybe<TOffice>;
  createOneOffEvent: Maybe<TLambdaConnection>;
  createProduct: Maybe<TProduct>;
  createReferenceEvent: Maybe<TReferenceEvent>;
  createRosterFile: Maybe<TRosterFile>;
  createShipment: Maybe<TShipment>;
  createShipmentWithGifts: Maybe<TShipment>;
  createUser: Maybe<TUser>;
  deleteAddress: Maybe<TAddress>;
  deleteCompany: Maybe<TCompany>;
  deleteDependant: Maybe<TDependant>;
  deleteEmployee: Maybe<TEmployee>;
  deleteEvent: Maybe<TEvent>;
  deleteGift: Maybe<TGift>;
  deleteGiftPackage: Maybe<TGiftPackage>;
  deleteOffice: Maybe<TOffice>;
  deleteProduct: Maybe<TProduct>;
  deleteReferenceEvent: Maybe<TReferenceEvent>;
  deleteShipment: Maybe<TShipment>;
  deleteUser: Maybe<TUser>;
  moveGift: Maybe<TGift>;
  moveShipment: Maybe<TShipment>;
  notifyNewHires: Maybe<Scalars['Boolean']['output']>;
  pauseEmployeeGifts: Maybe<TEmployee>;
  printCUSMA: Maybe<TShipment>;
  printLabelPhysically: Maybe<TShipment>;
  printShipmentLabel: Maybe<TShipment>;
  recreateShipment: Maybe<TShipmentRecreatedResponse>;
  refreshCompanyEmployeeCount: Maybe<TCompany>;
  removeGiftFromGroup: Maybe<TRemovedGiftFromGroupResponse>;
  reshipShipment: Maybe<TShipment>;
  resyncShipmentWithShipStation: Maybe<TShipment>;
  setShipmentAsDelivered: Maybe<TShipment>;
  setShipmentAsPickedUp: Maybe<TShipment>;
  setShipmentAsReadyToShip: Maybe<TShipment>;
  setShipmentAsReturned: Maybe<TShipment>;
  setShipmentAsShipped: Maybe<TShipment>;
  setShipmentForPickup: Maybe<TShipment>;
  shipmentLabelPrinted: Maybe<TShipment>;
  skipAddressAlert: Maybe<TAddress>;
  skipEvent: Maybe<TEvent>;
  softDeleteCompany: Maybe<TCompany>;
  transferOwnership: Maybe<Array<Maybe<TUser>>>;
  unpauseEmployeeGifts: Maybe<TEmployee>;
  unskipEvent: Maybe<TEvent>;
  updateCompany: Maybe<TCompany>;
  updateCompanyConfiguration: Maybe<TCompany>;
  updateDependant: Maybe<TDependant>;
  updateEmployee: Maybe<TEmployee>;
  updateEvent: Maybe<TEvent>;
  updateGift: Maybe<TGift>;
  updateGiftPackage: Maybe<TGiftPackage>;
  updateOffice: Maybe<TOffice>;
  updateProduct: Maybe<TProduct>;
  updateReferenceEvent: Maybe<TReferenceEvent>;
  updateRosterFile: Maybe<TRosterFile>;
  updateShipment: Maybe<TShipment>;
  updateUser: Maybe<TUser>;
};

export type TMutationAddAlertToGiftArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: TAlertInput;
};

export type TMutationAddAlertToShipmentArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: TAlertInput;
};

export type TMutationAddGiftsToShipmentArgs = {
  companyId: Scalars['ID']['input'];
  giftsIds: Array<Scalars['ID']['input']>;
  shipmentId: Scalars['ID']['input'];
};

export type TMutationCancelShipmentForPickupArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationCreateCsUserArgs = {
  companyId: Scalars['ID']['input'];
};

export type TMutationCreateCompanyArgs = {
  input: TCreateCompanyMutationInput;
};

export type TMutationCreateDependantArgs = {
  input: TCreateDependantMutationInput;
};

export type TMutationCreateEmployeeArgs = {
  input: TCreateEmployeeMutationInput;
};

export type TMutationCreateEventArgs = {
  input: TCreateEventMutationInput;
};

export type TMutationCreateEventGiftArgs = {
  _eventVersion: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
  group?: InputMaybe<Scalars['String']['input']>;
  referenceEventDate?: InputMaybe<Scalars['AWSDate']['input']>;
  shippingDate?: InputMaybe<Scalars['AWSDate']['input']>;
};

export type TMutationCreateGiftArgs = {
  input: TCreateGiftMutationInput;
};

export type TMutationCreateGiftPackageArgs = {
  input: TCreateGiftPackageMutationInput;
};

export type TMutationCreateOfficeArgs = {
  input: TCreateOfficeMutationInput;
};

export type TMutationCreateOneOffEventArgs = {
  input: Scalars['AWSJSON']['input'];
};

export type TMutationCreateProductArgs = {
  input: TCreateProductMutationInput;
};

export type TMutationCreateReferenceEventArgs = {
  input: TCreateReferenceEventMutationInput;
};

export type TMutationCreateRosterFileArgs = {
  input: TCreateRosterFileInput;
};

export type TMutationCreateShipmentArgs = {
  input: TCreateShipmentMutationInput;
};

export type TMutationCreateShipmentWithGiftsArgs = {
  input: TCreateShipmentWithGiftsMutationInput;
};

export type TMutationCreateUserArgs = {
  input: TCreateUserMutationInput;
};

export type TMutationDeleteAddressArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationDeleteCompanyArgs = {
  _version: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationDeleteDependantArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationDeleteEmployeeArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationDeleteEventArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationDeleteGiftArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationDeleteGiftPackageArgs = {
  _version: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationDeleteOfficeArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationDeleteProductArgs = {
  _version: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationDeleteReferenceEventArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationDeleteShipmentArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationDeleteUserArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  email: Scalars['AWSEmail']['input'];
};

export type TMutationMoveGiftArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: TMoveGiftMutationInput;
};

export type TMutationMoveShipmentArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: TMoveShipmentMutationInput;
};

export type TMutationNotifyNewHiresArgs = {
  events: Array<InputMaybe<TNotifyNewHireMutationInput>>;
};

export type TMutationPauseEmployeeGiftsArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  fromDate?: InputMaybe<Scalars['AWSDate']['input']>;
  id: Scalars['ID']['input'];
  toDate?: InputMaybe<Scalars['AWSDate']['input']>;
};

export type TMutationPrintCusmaArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationPrintLabelPhysicallyArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationPrintShipmentLabelArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: TPrintShipmentLabelMutationInput;
};

export type TMutationRecreateShipmentArgs = {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationRefreshCompanyEmployeeCountArgs = {
  id: Scalars['ID']['input'];
};

export type TMutationRemoveGiftFromGroupArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationReshipShipmentArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationResyncShipmentWithShipStationArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationSetShipmentAsDeliveredArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationSetShipmentAsPickedUpArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationSetShipmentAsReadyToShipArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: TSetShipmentAsReadyToShipMutationInput;
};

export type TMutationSetShipmentAsReturnedArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationSetShipmentAsShippedArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationSetShipmentForPickupArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationShipmentLabelPrintedArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: TShipmentLabelPrintedMutationInput;
};

export type TMutationSkipAddressAlertArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationSkipEventArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationSoftDeleteCompanyArgs = {
  _version: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationTransferOwnershipArgs = {
  _oldOwnerVersion: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  newOwnerEmail: Scalars['AWSEmail']['input'];
  oldOwnerEmail: Scalars['AWSEmail']['input'];
};

export type TMutationUnpauseEmployeeGiftsArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationUnskipEventArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TMutationUpdateCompanyArgs = {
  _version: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  input: TUpdateCompanyMutationInput;
};

export type TMutationUpdateCompanyConfigurationArgs = {
  _version: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  input: TUpdateCompanyConfigurationMutationInput;
};

export type TMutationUpdateDependantArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: TUpdateDependantMutationInput;
};

export type TMutationUpdateEmployeeArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: TUpdateEmployeeMutationInput;
};

export type TMutationUpdateEventArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: TUpdateEventMutationInput;
};

export type TMutationUpdateGiftArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: TUpdateGiftMutationInput;
};

export type TMutationUpdateGiftPackageArgs = {
  _version: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  input: TUpdateGiftPackageMutationInput;
};

export type TMutationUpdateOfficeArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: TUpdateOfficeMutationInput;
};

export type TMutationUpdateProductArgs = {
  _version: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  input: TUpdateProductMutationInput;
};

export type TMutationUpdateReferenceEventArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: TUpdateReferenceEventMutationInput;
};

export type TMutationUpdateRosterFileArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: TUpdateRosterFileInput;
};

export type TMutationUpdateShipmentArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  input: TUpdateShipmentMutationInput;
};

export type TMutationUpdateUserArgs = {
  _version: Scalars['Int']['input'];
  companyId: Scalars['ID']['input'];
  email: Scalars['AWSEmail']['input'];
  input: TUpdateUserMutationInput;
};

export type TNotifyNewHireMutationInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  employeeName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TOffice = {
  __typename?: 'Office';
  _deleted: Maybe<Scalars['Boolean']['output']>;
  _lastChangedAt: Maybe<Scalars['AWSTimestamp']['output']>;
  _version: Scalars['Int']['output'];
  active: Scalars['Boolean']['output'];
  address: Maybe<TAddress>;
  company: Maybe<TCompany>;
  companyId: Scalars['ID']['output'];
  contact: Maybe<TContact>;
  createdAt: Maybe<Scalars['AWSDateTime']['output']>;
  employees: TEmployeesConnection;
  id: Scalars['ID']['output'];
  legalName: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  normalizedName: Maybe<Scalars['String']['output']>;
  oldSystemId: Maybe<Scalars['Int']['output']>;
  updatedAt: Maybe<Scalars['AWSDateTime']['output']>;
};

export type TOfficeEmployeesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TOfficesConnection = {
  __typename?: 'OfficesConnection';
  items: Array<Maybe<TOffice>>;
  nextToken: Maybe<Scalars['String']['output']>;
  scannedCount: Maybe<Scalars['Int']['output']>;
};

export enum TOrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type TOrderInput = {
  key: Scalars['String']['input'];
  order: TOrderDirection;
};

export type TPackageInfo = {
  __typename?: 'PackageInfo';
  height: Scalars['Float']['output'];
  length: Scalars['Float']['output'];
  weight: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
};

export type TPackageInfoInput = {
  height: Scalars['Float']['input'];
  length: Scalars['Float']['input'];
  weight: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
};

export type TPausePeriod = {
  __typename?: 'PausePeriod';
  fromDate: Scalars['AWSDate']['output'];
  toDate: Maybe<Scalars['AWSDate']['output']>;
  unpausedAt: Maybe<Scalars['AWSDateTime']['output']>;
};

export type TPrintShipmentLabelMutationInput = {
  actualShippingDate: Scalars['AWSDate']['input'];
  customsData?: InputMaybe<Array<InputMaybe<TCustomsDataInput>>>;
};

export type TProduct = {
  __typename?: 'Product';
  _deleted: Maybe<Scalars['Boolean']['output']>;
  _lastChangedAt: Maybe<Scalars['AWSTimestamp']['output']>;
  _version: Scalars['Int']['output'];
  country: Scalars['String']['output'];
  createdAt: Maybe<Scalars['AWSDateTime']['output']>;
  description: Scalars['String']['output'];
  hsCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  manufacturerNsProductId: Maybe<Scalars['String']['output']>;
  manufacturerProductId: Maybe<Scalars['String']['output']>;
  manufacturerProductIdType: Maybe<TManufacturerProductIdType>;
  originCriterion: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  sku: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['AWSDateTime']['output']>;
  value: Scalars['Float']['output'];
};

export type TProductsConnection = {
  __typename?: 'ProductsConnection';
  items: Array<Maybe<TProduct>>;
  nextToken: Maybe<Scalars['String']['output']>;
  scannedCount: Maybe<Scalars['Int']['output']>;
};

export type TQuery = {
  __typename?: 'Query';
  customReport: Array<TCustomReportRow>;
  eventsReport: Array<TEventsReportRow>;
  financialReport: Array<TFinancialReportRow>;
  getAddress: Maybe<TAddress>;
  getAddressById: Maybe<TAddress>;
  getCompany: Maybe<TCompany>;
  getCompanyByName: Maybe<TCompany>;
  getCompanyByOldSystemId: Maybe<TCompany>;
  getCompanyByRosterId: Maybe<TCompany>;
  getCompanyBySubdomain: Maybe<TCompany>;
  getCompanyByUserPoolId: Maybe<TCompany>;
  getDependant: Maybe<TDependant>;
  getDependantByOldSystemId: Maybe<TDependant>;
  getEmployee: Maybe<TEmployee>;
  getEmployeeByExternalId: Maybe<TEmployee>;
  getEmployeeByOldSystemId: Maybe<TEmployee>;
  getEvent: Maybe<TEvent>;
  getGift: Maybe<TGift>;
  getGiftByOldSystemId: Maybe<TGift>;
  getGiftPackage: Maybe<TGiftPackage>;
  getMyCompany: Maybe<TCompany>;
  getOffice: Maybe<TOffice>;
  getOfficeByName: Maybe<TOffice>;
  getOfficeByOldSystemId: Maybe<TOffice>;
  getProduct: Maybe<TProduct>;
  getRecipient: Maybe<TRecipient>;
  getReferenceEvent: Maybe<TReferenceEvent>;
  getRosterFile: Maybe<TRosterFile>;
  getShipment: Maybe<TShipment>;
  getShipmentByOldSystemId: Maybe<TShipment>;
  getShipmentByTrackingNumber: Maybe<TShipment>;
  getUser: Maybe<TUser>;
  giftsReport: Array<TGiftsReportRow>;
  listAddresses: TAddressesConnection;
  listAddressesByCompanyId: TAddressesConnection;
  listAdminCognitoUsers: Maybe<Scalars['AWSJSON']['output']>;
  listAllAddresses: TAddressesConnection;
  listAllCompanies: TCompaniesConnection;
  listAllEmployees: TEmployeesConnection;
  listAllEvents: TEventsConnection;
  listAllLogs: TLogsConnection;
  listAllOffices: TOfficesConnection;
  listAllReferenceEvents: TReferenceEventsConnection;
  listClientOneOffEvents: TEventsConnection;
  listClosedShipments: TShipmentsConnection;
  listCompanies: TCompaniesConnection;
  listCompanyDependants: TDependantsConnection;
  listCompanyEmployees: TEmployeesConnection;
  listCompanyReferenceEvents: TReferenceEventsConnection;
  listCompanyShipments: TShipmentsConnection;
  listCompanyUpcomingEvents: TEventsConnection;
  listDefaultGiftPackages: TGiftPackageConnection;
  listDependants: TDependantsConnection;
  listEmployeeAndDependantsNotSkippedWithoutGiftEvents: TEventsConnection;
  listEmployeeAndDependatsGifts: TGiftsConnection;
  listEmployeeDependants: TDependantsConnection;
  listEmployeeReferenceEvents: TReferenceEventsConnection;
  listEmployees: TEmployeesConnection;
  listEvents: TEventsConnection;
  listGiftPackages: TGiftPackageConnection;
  listGiftsAssembling: TGiftsConnection;
  listGiftsByGroup: TGiftsConnection;
  listNotDoneGifts: TGiftsConnection;
  listNotSkippedEventsWithoutGift: TEventsConnection;
  listOffices: TOfficesConnection;
  listOneAddress: TAddressesConnection;
  listOneCompany: TCompaniesConnection;
  listOneCompanyEmployees: TEmployeesConnection;
  listOneCompanyGiftPackages: TGiftPackageConnection;
  listOneEmployee: TEmployeesConnection;
  listOneEvent: TEventsConnection;
  listOneGift: TGiftsConnection;
  listOneGiftPackage: TGiftPackageConnection;
  listOneOfficeEmployees: TEmployeesConnection;
  listOneShipment: TShipmentsConnection;
  listOneShipmentGifts: TGiftsConnection;
  listOneSubTypeGiftPackages: TGiftPackageConnection;
  listOneTypeGiftPackages: TGiftPackageConnection;
  listOpenShipments: TShipmentsConnection;
  listOpenShipmentsNEW: TShipmentsConnection;
  listProducts: TProductsConnection;
  listRecentSetForPickupShipments: Maybe<TShipmentsConnection>;
  listRecentShippedShipments: Maybe<TShipmentsConnection>;
  listRecentlyDoneGifts: TGiftsConnection;
  listRecipientGifts: TGiftsConnection;
  listRecipientReferenceEvents: TReferenceEventsConnection;
  listReferenceEventEvents: TEventsConnection;
  listReferenceEventEventsWithGift: TEventsConnection;
  listReferenceEventEventsWithoutGift: TEventsConnection;
  listReferenceEventOnProgressEvents: TEventsConnection;
  listReferenceEventUpcomingEvents: TEventsConnection;
  listReferenceEventsByDate: TReferenceEventsConnection;
  listRosterFiles: TRosterFilesConnection;
  listRosterFilesByCompanyId: TRosterFilesConnection;
  listSetForPickupShipments: Maybe<TShipmentsConnection>;
  listShipmentGifts: TGiftsConnection;
  listShipmentsByAddress: TShipmentsConnection;
  listShipmentsByAddressAndStatus: TShipmentsConnection;
  listShipmentsPickupNEW: TShipmentsConnection;
  listShipmentsTrackingNEW: TShipmentsConnection;
  listShippedShipments: Maybe<TShipmentsConnection>;
  listSkippedEvents: TEventsConnection;
  listSkippedEventsNew: TEventsConnection;
  listTodayReferenceEvents: TReferenceEventsConnection;
  listUsers: TUsersConnection;
  listUsersIncludingCSUsers: TUsersConnection;
  reportGiftsByCompanyIdAndCreatedAt: TGiftsConnection;
  rosterFilesReport: Array<TRosterFilesReportRow>;
  searchEventsByRecipient: TEventsConnection;
  shipmentsReport: Array<TShipmentsReportRow>;
};

export type TQueryCustomReportArgs = {
  input: TCustomReportInput;
};

export type TQueryEventsReportArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  month: Scalars['String']['input'];
};

export type TQueryFinancialReportArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  month: Scalars['String']['input'];
};

export type TQueryGetAddressArgs = {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TQueryGetAddressByIdArgs = {
  id: Scalars['ID']['input'];
};

export type TQueryGetCompanyArgs = {
  id: Scalars['ID']['input'];
};

export type TQueryGetCompanyByNameArgs = {
  name: Scalars['String']['input'];
};

export type TQueryGetCompanyByOldSystemIdArgs = {
  oldSystemId: Scalars['Int']['input'];
};

export type TQueryGetCompanyByRosterIdArgs = {
  rosterId: Scalars['String']['input'];
};

export type TQueryGetCompanyBySubdomainArgs = {
  subdomain: Scalars['String']['input'];
};

export type TQueryGetCompanyByUserPoolIdArgs = {
  userPoolId: Scalars['String']['input'];
};

export type TQueryGetDependantArgs = {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TQueryGetDependantByOldSystemIdArgs = {
  oldSystemId: Scalars['Int']['input'];
};

export type TQueryGetEmployeeArgs = {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TQueryGetEmployeeByExternalIdArgs = {
  externalId: Scalars['String']['input'];
};

export type TQueryGetEmployeeByOldSystemIdArgs = {
  oldSystemId: Scalars['Int']['input'];
};

export type TQueryGetEventArgs = {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TQueryGetGiftArgs = {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TQueryGetGiftByOldSystemIdArgs = {
  oldSystemId: Scalars['Int']['input'];
};

export type TQueryGetGiftPackageArgs = {
  id: Scalars['ID']['input'];
};

export type TQueryGetOfficeArgs = {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TQueryGetOfficeByNameArgs = {
  companyId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type TQueryGetOfficeByOldSystemIdArgs = {
  oldSystemId: Scalars['Int']['input'];
};

export type TQueryGetProductArgs = {
  id: Scalars['ID']['input'];
};

export type TQueryGetRecipientArgs = {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TQueryGetReferenceEventArgs = {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TQueryGetRosterFileArgs = {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TQueryGetShipmentArgs = {
  companyId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
};

export type TQueryGetShipmentByOldSystemIdArgs = {
  oldSystemId: Scalars['Int']['input'];
};

export type TQueryGetShipmentByTrackingNumberArgs = {
  trackingNumber: Scalars['ID']['input'];
};

export type TQueryGetUserArgs = {
  companyId: Scalars['ID']['input'];
  email: Scalars['AWSEmail']['input'];
};

export type TQueryGiftsReportArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  month: Scalars['String']['input'];
};

export type TQueryListAddressesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListAddressesByCompanyIdArgs = {
  companyId: Scalars['ID']['input'];
  filter?: InputMaybe<TFilterInput>;
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListAdminCognitoUsersArgs = {
  onlyCS?: InputMaybe<Scalars['Boolean']['input']>;
  userPoolId: Scalars['String']['input'];
};

export type TQueryListAllAddressesArgs = {
  filter?: InputMaybe<TFilterInput>;
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListAllCompaniesArgs = {
  filter?: InputMaybe<TFilterInput>;
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListAllEmployeesArgs = {
  filter?: InputMaybe<TFilterInput>;
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListAllEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListAllLogsArgs = {
  filter?: InputMaybe<TFilterInput>;
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  occurredAt?: InputMaybe<Scalars['String']['input']>;
  onlyCS?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<TOrderDirection>;
  userPoolId?: InputMaybe<Scalars['String']['input']>;
  userType: Scalars['String']['input'];
};

export type TQueryListAllOfficesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListAllReferenceEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListClientOneOffEventsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  eventPage: Scalars['String']['input'];
  filter?: InputMaybe<TFilterInput>;
  includingLastDays?: InputMaybe<Scalars['Int']['input']>;
  includingNextDays?: InputMaybe<Scalars['Int']['input']>;
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListClosedShipmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListCompaniesArgs = {
  filter?: InputMaybe<TFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<TOrderInput>>>;
};

export type TQueryListCompanyDependantsArgs = {
  companyId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListCompanyEmployeesArgs = {
  companyId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListCompanyReferenceEventsArgs = {
  companyId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListCompanyShipmentsArgs = {
  companyId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListCompanyUpcomingEventsArgs = {
  companyId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListDefaultGiftPackagesArgs = {
  filter?: InputMaybe<TFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListDependantsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListEmployeeAndDependantsNotSkippedWithoutGiftEventsArgs = {
  employeeId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListEmployeeAndDependatsGiftsArgs = {
  companyId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListEmployeeDependantsArgs = {
  companyId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListEmployeeReferenceEventsArgs = {
  companyId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListEmployeesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListEventsArgs = {
  eventPage: Scalars['String']['input'];
  filter?: InputMaybe<TFilterInput>;
  includingLastDays?: InputMaybe<Scalars['Int']['input']>;
  includingNextDays?: InputMaybe<Scalars['Int']['input']>;
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
  type: Scalars['String']['input'];
};

export type TQueryListGiftPackagesArgs = {
  filter?: InputMaybe<TFilterInput>;
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListGiftsAssemblingArgs = {
  filter?: InputMaybe<TFilterInput>;
  isDone?: InputMaybe<Scalars['Int']['input']>;
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TQueryListGiftsByGroupArgs = {
  companyId: Scalars['String']['input'];
  group: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  ordedr?: InputMaybe<TOrderDirection>;
};

export type TQueryListNotDoneGiftsArgs = {
  filter?: InputMaybe<TFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListNotSkippedEventsWithoutGiftArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListOfficesArgs = {
  companyId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListOneAddressArgs = {
  filter?: InputMaybe<TFilterInput>;
  id: Scalars['ID']['input'];
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListOneCompanyArgs = {
  filter?: InputMaybe<TFilterInput>;
  id: Scalars['ID']['input'];
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListOneCompanyEmployeesArgs = {
  companyId: Scalars['ID']['input'];
  filter?: InputMaybe<TFilterInput>;
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListOneCompanyGiftPackagesArgs = {
  companyId: Scalars['ID']['input'];
  filter?: InputMaybe<TFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListOneEmployeeArgs = {
  filter?: InputMaybe<TFilterInput>;
  id: Scalars['ID']['input'];
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListOneEventArgs = {
  filter?: InputMaybe<TFilterInput>;
  id: Scalars['ID']['input'];
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListOneGiftArgs = {
  filter?: InputMaybe<TFilterInput>;
  id: Scalars['ID']['input'];
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListOneGiftPackageArgs = {
  filter?: InputMaybe<TFilterInput>;
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListOneOfficeEmployeesArgs = {
  filter?: InputMaybe<TFilterInput>;
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  officeId: Scalars['ID']['input'];
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListOneShipmentArgs = {
  filter?: InputMaybe<TFilterInput>;
  id: Scalars['ID']['input'];
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListOneShipmentGiftsArgs = {
  filter?: InputMaybe<TFilterInput>;
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
  shipmentId: Scalars['ID']['input'];
};

export type TQueryListOneSubTypeGiftPackagesArgs = {
  filter?: InputMaybe<TFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
  subType: Scalars['String']['input'];
};

export type TQueryListOneTypeGiftPackagesArgs = {
  filter?: InputMaybe<TFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
  type: Scalars['String']['input'];
};

export type TQueryListOpenShipmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListOpenShipmentsNewArgs = {
  filter?: InputMaybe<TFilterInput>;
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListRecentSetForPickupShipmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListRecentShippedShipmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListRecentlyDoneGiftsArgs = {
  filter?: InputMaybe<TFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListRecipientGiftsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
  recipientId: Scalars['ID']['input'];
};

export type TQueryListRecipientReferenceEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
  recipientId: Scalars['ID']['input'];
};

export type TQueryListReferenceEventEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
  referenceEventId: Scalars['ID']['input'];
};

export type TQueryListReferenceEventEventsWithGiftArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
  referenceEventId: Scalars['ID']['input'];
};

export type TQueryListReferenceEventEventsWithoutGiftArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
  referenceEventId: Scalars['ID']['input'];
};

export type TQueryListReferenceEventOnProgressEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
  referenceEventId: Scalars['ID']['input'];
};

export type TQueryListReferenceEventUpcomingEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
  referenceEventId: Scalars['ID']['input'];
};

export type TQueryListReferenceEventsByDateArgs = {
  date: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListRosterFilesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListRosterFilesByCompanyIdArgs = {
  companyId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListSetForPickupShipmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListShipmentGiftsArgs = {
  companyId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
  shipmentId: Scalars['ID']['input'];
};

export type TQueryListShipmentsByAddressArgs = {
  addressId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListShipmentsByAddressAndStatusArgs = {
  addressId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
  status: TShipmentStatuses;
};

export type TQueryListShipmentsPickupNewArgs = {
  filter?: InputMaybe<TFilterInput>;
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
  setForPickupAt?: InputMaybe<Scalars['String']['input']>;
};

export type TQueryListShipmentsTrackingNewArgs = {
  filter?: InputMaybe<TFilterInput>;
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
  shippedAt?: InputMaybe<Scalars['String']['input']>;
};

export type TQueryListShippedShipmentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListSkippedEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListSkippedEventsNewArgs = {
  eventPage: Scalars['String']['input'];
  filter?: InputMaybe<TFilterInput>;
  includingLastDays?: InputMaybe<Scalars['Int']['input']>;
  includingNextDays?: InputMaybe<Scalars['Int']['input']>;
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListTodayReferenceEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListUsersArgs = {
  companyId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryListUsersIncludingCsUsersArgs = {
  companyId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryReportGiftsByCompanyIdAndCreatedAtArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TFilterInput>;
  isScan?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TOrderDirection>;
};

export type TQueryRosterFilesReportArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  month: Scalars['String']['input'];
};

export type TQuerySearchEventsByRecipientArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  eventPage?: InputMaybe<Scalars['String']['input']>;
  includingLastDays?: InputMaybe<Scalars['Int']['input']>;
  includingNextDays?: InputMaybe<Scalars['Int']['input']>;
  recipientName: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type TQueryShipmentsReportArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  month: Scalars['String']['input'];
};

export type TRecipient = {
  _deleted: Maybe<Scalars['Boolean']['output']>;
  _lastChangedAt: Maybe<Scalars['AWSTimestamp']['output']>;
  _version: Maybe<Scalars['Int']['output']>;
  address: Maybe<TAddress>;
  birthDate: Maybe<Scalars['AWSDate']['output']>;
  companyId: Scalars['ID']['output'];
  createdAt: Maybe<Scalars['AWSDateTime']['output']>;
  donateBirthdayGift: Maybe<Scalars['Boolean']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  foodPreferences: Maybe<Scalars['String']['output']>;
  fullName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  preferredFirstName: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['AWSDateTime']['output']>;
};

export type TReferenceEvent = {
  __typename?: 'ReferenceEvent';
  _deleted: Maybe<Scalars['Boolean']['output']>;
  _lastChangedAt: Maybe<Scalars['AWSTimestamp']['output']>;
  _version: Scalars['Int']['output'];
  address: Maybe<TAddress>;
  addressId: Maybe<Scalars['ID']['output']>;
  company: Maybe<TCompany>;
  companyId: Scalars['ID']['output'];
  createdAt: Maybe<Scalars['AWSDateTime']['output']>;
  date: Scalars['String']['output'];
  employee: Maybe<TEmployee>;
  employeeId: Scalars['ID']['output'];
  fullDate: Scalars['AWSDate']['output'];
  id: Scalars['ID']['output'];
  recipient: Maybe<TRecipient>;
  recipientId: Scalars['ID']['output'];
  type: TReferenceEventTypes;
  updatedAt: Maybe<Scalars['AWSDateTime']['output']>;
};

export enum TReferenceEventTypes {
  Birthday = 'birthday',
  WorkAnniversary = 'workAnniversary'
}

export type TReferenceEventsConnection = {
  __typename?: 'ReferenceEventsConnection';
  items: Array<Maybe<TReferenceEvent>>;
  nextToken: Maybe<Scalars['String']['output']>;
  scannedCount: Maybe<Scalars['Int']['output']>;
};

export type TRemovedGiftFromGroupResponse = {
  __typename?: 'RemovedGiftFromGroupResponse';
  companyId: Scalars['ID']['output'];
  items: Array<Maybe<TGift>>;
};

export type TRosterFile = {
  __typename?: 'RosterFile';
  _deleted: Maybe<Scalars['Boolean']['output']>;
  _lastChangedAt: Maybe<Scalars['AWSTimestamp']['output']>;
  _version: Scalars['Int']['output'];
  changelog: Maybe<Scalars['AWSJSON']['output']>;
  changelogFile: Maybe<TRosterFileS3Object>;
  company: Maybe<TCompany>;
  companyId: Scalars['ID']['output'];
  createdAt: Maybe<Scalars['AWSDateTime']['output']>;
  createdBy: Maybe<TRosterFileCreatedBy>;
  file: TRosterFileS3Object;
  headerMapping: Maybe<Scalars['AWSJSON']['output']>;
  id: Scalars['ID']['output'];
  impoortEndedAt: Maybe<Scalars['AWSDateTime']['output']>;
  importErrors: Maybe<Scalars['AWSJSON']['output']>;
  importStartedAt: Maybe<Scalars['AWSDateTime']['output']>;
  mapping: Scalars['AWSJSON']['output'];
  officeMapping: Maybe<Scalars['AWSJSON']['output']>;
  updatedAt: Maybe<Scalars['AWSDateTime']['output']>;
};

export type TRosterFileCreatedBy = {
  __typename?: 'RosterFileCreatedBy';
  sub: Maybe<Scalars['String']['output']>;
  username: Maybe<Scalars['String']['output']>;
};

export type TRosterFileS3Object = {
  __typename?: 'RosterFileS3Object';
  bucket: Scalars['String']['output'];
  key: Scalars['String']['output'];
  region: Scalars['String']['output'];
  version: Maybe<Scalars['String']['output']>;
};

export type TRosterFilesConnection = {
  __typename?: 'RosterFilesConnection';
  items: Array<Maybe<TRosterFile>>;
  nextToken: Maybe<Scalars['String']['output']>;
  scannedCount: Maybe<Scalars['Int']['output']>;
};

export type TRosterFilesReportRow = {
  __typename?: 'RosterFilesReportRow';
  changelog: Maybe<Scalars['AWSJSON']['output']>;
  changelogFile: Maybe<TRosterFileS3Object>;
  companyId: Scalars['ID']['output'];
  companyName: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  file: TRosterFileS3Object;
  headerMapping: Maybe<Scalars['AWSJSON']['output']>;
  impoortEndedAt: Maybe<Scalars['AWSDateTime']['output']>;
  importErrors: Maybe<Scalars['AWSJSON']['output']>;
  importStartedAt: Maybe<Scalars['AWSDateTime']['output']>;
  mapping: Scalars['AWSJSON']['output'];
  officeMapping: Maybe<Scalars['AWSJSON']['output']>;
};

export type TS3Object = {
  __typename?: 'S3Object';
  bucket: Scalars['String']['output'];
  key: Scalars['String']['output'];
  region: Scalars['String']['output'];
  version: Maybe<Scalars['String']['output']>;
};

export type TS3ObjectInput = {
  bucket: Scalars['String']['input'];
  key: Scalars['String']['input'];
  region: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

export type TSetShipmentAsReadyToShipMutationInput = {
  packageInfo: TPackageInfoInput;
};

export enum TShipStationAddressVerified {
  Failed = 'failed',
  Pending = 'pending',
  Success = 'success',
  Warning = 'warning'
}

export type TShipment = {
  __typename?: 'Shipment';
  _deleted: Maybe<Scalars['Boolean']['output']>;
  _lastChangedAt: Maybe<Scalars['AWSTimestamp']['output']>;
  _version: Scalars['Int']['output'];
  actualShippingDate: Maybe<Scalars['AWSDate']['output']>;
  address: Maybe<TAddress>;
  addressId: Scalars['ID']['output'];
  addressTypeIcon: Maybe<Scalars['String']['output']>;
  addressVerified: Maybe<TShipStationAddressVerified>;
  alerts: Maybe<Array<Maybe<TAlert>>>;
  company: Maybe<TCompany>;
  companyId: Scalars['ID']['output'];
  createdAt: Maybe<Scalars['AWSDateTime']['output']>;
  customsData: Maybe<Array<Maybe<TCustomsData>>>;
  deliveredAt: Maybe<Scalars['AWSDateTime']['output']>;
  employee: Maybe<TEmployee>;
  giftPacks: Maybe<Scalars['AWSJSON']['output']>;
  gifts: Maybe<TGiftsConnection>;
  history: Maybe<Array<Maybe<TShipmentHistory>>>;
  id: Scalars['ID']['output'];
  isPrintedCUSMA: Maybe<Scalars['Boolean']['output']>;
  isPrintedPhysically: Maybe<Scalars['Boolean']['output']>;
  label: Maybe<TShipmentLabel>;
  lastShipStationResyncStartedAt: Maybe<Scalars['AWSDateTime']['output']>;
  name: Maybe<Scalars['String']['output']>;
  notes: Maybe<Scalars['String']['output']>;
  office: Maybe<TOffice>;
  oldAddressId: Maybe<Scalars['ID']['output']>;
  oldSystemId: Maybe<Scalars['Int']['output']>;
  overrideCarrier: Maybe<Scalars['String']['output']>;
  overrideService: Maybe<Scalars['String']['output']>;
  packageInfo: Maybe<TPackageInfo>;
  pickedUpAt: Maybe<Scalars['AWSDateTime']['output']>;
  rack: Maybe<Scalars['String']['output']>;
  readableAddressType: Maybe<Scalars['String']['output']>;
  recipient: Maybe<TRecipient>;
  recipientName: Maybe<Scalars['String']['output']>;
  resyncWithShipStation: Maybe<Scalars['Boolean']['output']>;
  returnedAt: Maybe<Scalars['AWSDateTime']['output']>;
  setForPickupAt: Maybe<Scalars['AWSDateTime']['output']>;
  shipStationError: Maybe<Scalars['AWSJSON']['output']>;
  shipStationOrderId: Maybe<Scalars['Int']['output']>;
  shipStationResyncCount: Maybe<Scalars['Int']['output']>;
  shipStationShipmentId: Maybe<Scalars['Int']['output']>;
  shippedAt: Maybe<Scalars['AWSDateTime']['output']>;
  shippingDate: Maybe<Scalars['AWSDate']['output']>;
  status: TShipmentStatuses;
  trackingNumber: Maybe<Scalars['String']['output']>;
  trackingURL: Maybe<Scalars['String']['output']>;
  updatedAt: Maybe<Scalars['AWSDateTime']['output']>;
  useGoogleAddress: Maybe<Scalars['Boolean']['output']>;
};

export type TShipmentHistory = {
  __typename?: 'ShipmentHistory';
  actualShippingDate: Maybe<Scalars['AWSDate']['output']>;
  addressVerified: Maybe<TShipStationAddressVerified>;
  alerts: Maybe<Array<Maybe<TAlert>>>;
  customsData: Maybe<Array<Maybe<TCustomsData>>>;
  deliveredAt: Maybe<Scalars['AWSDateTime']['output']>;
  label: Maybe<TShipmentLabel>;
  notes: Maybe<Scalars['String']['output']>;
  packageInfo: Maybe<TPackageInfo>;
  pickedUpAt: Maybe<Scalars['AWSDateTime']['output']>;
  rack: Maybe<Scalars['String']['output']>;
  returnedAt: Maybe<Scalars['AWSDateTime']['output']>;
  setForPickupAt: Maybe<Scalars['AWSDateTime']['output']>;
  shipStationOrderId: Maybe<Scalars['Int']['output']>;
  shipStationShipmentId: Maybe<Scalars['Int']['output']>;
  shippedAt: Maybe<Scalars['AWSDateTime']['output']>;
  trackingNumber: Maybe<Scalars['String']['output']>;
  trackingURL: Maybe<Scalars['String']['output']>;
};

export type TShipmentLabel = {
  __typename?: 'ShipmentLabel';
  addressData: Maybe<TAddress>;
  carrier: Scalars['String']['output'];
  cost: Scalars['Float']['output'];
  createdAt: Maybe<Scalars['AWSDateTime']['output']>;
  isThirdParty: Maybe<Scalars['Boolean']['output']>;
  labelFile: Maybe<TS3Object>;
};

export type TShipmentLabelInput = {
  addressData?: InputMaybe<Scalars['AWSJSON']['input']>;
  carrier: Scalars['String']['input'];
  cost?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  isThirdParty?: InputMaybe<Scalars['Boolean']['input']>;
  labelFile?: InputMaybe<TS3ObjectInput>;
};

export type TShipmentLabelPrintedMutationInput = {
  label: TShipmentLabelInput;
  trackingNumber: Scalars['String']['input'];
};

export type TShipmentRecreatedResponse = {
  __typename?: 'ShipmentRecreatedResponse';
  companyId: Scalars['ID']['output'];
  items: Array<Maybe<TGift>>;
};

export enum TShipmentStatuses {
  Attention = 'attention',
  Canceled = 'canceled',
  Delivered = 'delivered',
  Error = 'error',
  LabelPrinted = 'labelPrinted',
  Packaging = 'packaging',
  PickedUp = 'pickedUp',
  PrintingLabel = 'printingLabel',
  ReadyForPickup = 'readyForPickup',
  ReadyToShip = 'readyToShip',
  Returned = 'returned',
  Shipped = 'shipped',
  Unavailable = 'unavailable'
}

export type TShipmentsConnection = {
  __typename?: 'ShipmentsConnection';
  items: Array<Maybe<TShipment>>;
  nextToken: Maybe<Scalars['String']['output']>;
  scannedCount: Maybe<Scalars['Int']['output']>;
};

export type TShipmentsReportRow = {
  __typename?: 'ShipmentsReportRow';
  carrier: Scalars['String']['output'];
  clientCost: Scalars['Float']['output'];
  companyId: Scalars['ID']['output'];
  companyName: Scalars['String']['output'];
  date: Scalars['String']['output'];
  giftCount: Scalars['Int']['output'];
  recipient: Scalars['String']['output'];
  shipmentCost: Scalars['Float']['output'];
  shipmentType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  trackingNumber: Scalars['String']['output'];
};

export type TSubscription = {
  __typename?: 'Subscription';
  onAnyAddressChanged: Maybe<TAddress>;
  onAnyCompanyChanged: Maybe<TCompany>;
  onAnyDependantChanged: Maybe<TDependant>;
  onAnyEmployeeChanged: Maybe<TEmployee>;
  onAnyEventChanged: Maybe<TEvent>;
  onAnyEventGiftCreated: Maybe<TCreateEventGiftResponse>;
  onAnyGiftChanged: Maybe<TGift>;
  onAnyGiftPackageChanged: Maybe<TGiftPackage>;
  onAnyGiftRemovedFromGroup: Maybe<TRemovedGiftFromGroupResponse>;
  onAnyOfficeChanged: Maybe<TOffice>;
  onAnyOwnershipTransfered: Maybe<Array<Maybe<TUser>>>;
  onAnyProductChanged: Maybe<TProduct>;
  onAnyRosterFileChanged: Maybe<TRosterFile>;
  onAnyShipmentChanged: Maybe<TShipment>;
  onAnyShipmentRecreated: Maybe<TShipmentRecreatedResponse>;
  onAnyUserChanged: Maybe<TUser>;
  onCompanyAddressChanged: Maybe<TAddress>;
  onCompanyChanged: Maybe<TCompany>;
  onCompanyDependantChanged: Maybe<TDependant>;
  onCompanyEmployeeChanged: Maybe<TEmployee>;
  onCompanyEventChanged: Maybe<TEvent>;
  onCompanyEventGiftCreated: Maybe<TCreateEventGiftResponse>;
  onCompanyGiftChanged: Maybe<TGift>;
  onCompanyGiftRemovedFromGroup: Maybe<TRemovedGiftFromGroupResponse>;
  onCompanyOfficeChanged: Maybe<TOffice>;
  onCompanyOwnershipTransfered: Maybe<Array<Maybe<TUser>>>;
  onCompanyRosterFileChanged: Maybe<TRosterFile>;
  onCompanyShipmentChanged: Maybe<TShipment>;
  onCompanyShipmentRecreated: Maybe<TShipmentRecreatedResponse>;
  onCompanyUserChanged: Maybe<TUser>;
  onEmployeeDependantChanged: Maybe<TDependant>;
  onEmployeeGiftChanged: Maybe<TGift>;
};

export type TSubscriptionOnCompanyAddressChangedArgs = {
  companyId: Scalars['ID']['input'];
};

export type TSubscriptionOnCompanyChangedArgs = {
  id: Scalars['ID']['input'];
};

export type TSubscriptionOnCompanyDependantChangedArgs = {
  companyId: Scalars['ID']['input'];
};

export type TSubscriptionOnCompanyEmployeeChangedArgs = {
  companyId: Scalars['ID']['input'];
};

export type TSubscriptionOnCompanyEventChangedArgs = {
  companyId: Scalars['ID']['input'];
};

export type TSubscriptionOnCompanyEventGiftCreatedArgs = {
  companyId: Scalars['ID']['input'];
};

export type TSubscriptionOnCompanyGiftChangedArgs = {
  companyId: Scalars['ID']['input'];
};

export type TSubscriptionOnCompanyGiftRemovedFromGroupArgs = {
  companyId: Scalars['ID']['input'];
};

export type TSubscriptionOnCompanyOfficeChangedArgs = {
  companyId: Scalars['ID']['input'];
};

export type TSubscriptionOnCompanyOwnershipTransferedArgs = {
  companyId: Scalars['ID']['input'];
};

export type TSubscriptionOnCompanyRosterFileChangedArgs = {
  companyId: Scalars['ID']['input'];
};

export type TSubscriptionOnCompanyShipmentChangedArgs = {
  companyId: Scalars['ID']['input'];
};

export type TSubscriptionOnCompanyShipmentRecreatedArgs = {
  companyId: Scalars['ID']['input'];
};

export type TSubscriptionOnCompanyUserChangedArgs = {
  companyId: Scalars['ID']['input'];
};

export type TSubscriptionOnEmployeeDependantChangedArgs = {
  companyId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
};

export type TSubscriptionOnEmployeeGiftChangedArgs = {
  companyId: Scalars['ID']['input'];
  employeeId: Scalars['ID']['input'];
};

export type TUpdateAddressMutationInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  useGoogleAddress?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type TUpdateCompanyConfigurationMutationInput = {
  authCloudfrontDomain?: InputMaybe<Scalars['String']['input']>;
  authUserPoolClientId?: InputMaybe<Scalars['String']['input']>;
  authUserPoolClientName?: InputMaybe<Scalars['String']['input']>;
  authUserPoolDomainURL?: InputMaybe<Scalars['String']['input']>;
  authUserPoolId?: InputMaybe<Scalars['String']['input']>;
  authUserPoolName?: InputMaybe<Scalars['String']['input']>;
  frontendCertificateArn?: InputMaybe<Scalars['String']['input']>;
  frontendDistributionArn?: InputMaybe<Scalars['String']['input']>;
  frontendDistributionDomainName?: InputMaybe<Scalars['String']['input']>;
  frontendDistributionId?: InputMaybe<Scalars['String']['input']>;
};

export type TUpdateCompanyMutationInput = {
  accountManager?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<TUpdateAddressMutationInput>;
  bambooHRAPIKey?: InputMaybe<Scalars['String']['input']>;
  bambooHRPetsTableName?: InputMaybe<Scalars['String']['input']>;
  bambooHRSubdomain?: InputMaybe<Scalars['String']['input']>;
  childBirthdayActivated?: InputMaybe<Scalars['Boolean']['input']>;
  companyWideLegoCustomization?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<TUpdateContactMutationInput>;
  customLego?: InputMaybe<Scalars['Boolean']['input']>;
  customShippingConfiguration?: InputMaybe<Array<InputMaybe<TCustomShippingConfigurationInput>>>;
  customWorkAnniversaryNotes?: InputMaybe<Scalars['String']['input']>;
  deliveryMethod?: InputMaybe<TDeliveryMethod>;
  emailDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  employeeBirthdayActivated?: InputMaybe<Scalars['Boolean']['input']>;
  employeeNewHireKitActivated?: InputMaybe<Scalars['Boolean']['input']>;
  employeeWorkAnniversaryActivated?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['AWSDate']['input']>;
  googleLoginEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  hasCustomOnboardBrick?: InputMaybe<Scalars['Boolean']['input']>;
  importFromBambooHR?: InputMaybe<Scalars['Boolean']['input']>;
  isLive?: InputMaybe<Scalars['Boolean']['input']>;
  lastRosterUpload?: InputMaybe<Scalars['AWSDateTime']['input']>;
  legoActivated?: InputMaybe<Scalars['Boolean']['input']>;
  legoColor?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['AWSURL']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oldSystemId?: InputMaybe<Scalars['Int']['input']>;
  passwordLoginEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  petBirthdayActivated?: InputMaybe<Scalars['Boolean']['input']>;
  rosterId?: InputMaybe<Scalars['String']['input']>;
  signAs?: InputMaybe<Scalars['String']['input']>;
  significantOtherBirthdayActivated?: InputMaybe<Scalars['Boolean']['input']>;
  specialNote?: InputMaybe<Scalars['String']['input']>;
  spreadsheetId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['AWSDate']['input']>;
  subdomain?: InputMaybe<Scalars['String']['input']>;
  subscriptionPriceCurrency?: InputMaybe<Scalars['String']['input']>;
  subscriptionPricePerUser?: InputMaybe<Scalars['Float']['input']>;
  swag?: InputMaybe<Scalars['String']['input']>;
  tissueColor?: InputMaybe<Scalars['String']['input']>;
  workAnniversaryGiftVariation?: InputMaybe<TWorkAnniversaryGiftVariations>;
};

export type TUpdateContactMutationInput = {
  email?: InputMaybe<Scalars['AWSEmail']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type TUpdateDependantMutationInput = {
  birthDate?: InputMaybe<Scalars['AWSDate']['input']>;
  donateBirthdayGift?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  foodPreferences?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  oldSystemId?: InputMaybe<Scalars['Int']['input']>;
  petType?: InputMaybe<Scalars['String']['input']>;
  preferredFirstName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TDependantType>;
};

export type TUpdateEmployeeMutationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<TUpdateAddressMutationInput>;
  birthDate?: InputMaybe<Scalars['AWSDate']['input']>;
  customOnboardBrick?: InputMaybe<Scalars['String']['input']>;
  deliveryMethod?: InputMaybe<TDeliveryMethod>;
  donateBirthdayGift?: InputMaybe<Scalars['Boolean']['input']>;
  donateWorkAnniversaryGift?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['AWSEmail']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  foodPreferences?: InputMaybe<Scalars['String']['input']>;
  giftOnHoldFrom?: InputMaybe<Scalars['AWSDate']['input']>;
  giftOnHoldTo?: InputMaybe<Scalars['AWSDate']['input']>;
  giftPausedFrom?: InputMaybe<Scalars['AWSDate']['input']>;
  giftPausedTo?: InputMaybe<Scalars['AWSDate']['input']>;
  hireDate?: InputMaybe<Scalars['AWSDate']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  officeId?: InputMaybe<Scalars['ID']['input']>;
  oldSystemId?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferredFirstName?: InputMaybe<Scalars['String']['input']>;
  sweaterSize?: InputMaybe<Scalars['String']['input']>;
  tShirtSize?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TUpdateEventMutationInput = {
  addressId?: InputMaybe<Scalars['ID']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
  deliveredAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  eventDate?: InputMaybe<Scalars['AWSDate']['input']>;
  giftId?: InputMaybe<Scalars['ID']['input']>;
  groupedToEventId?: InputMaybe<Scalars['ID']['input']>;
  isPaused?: InputMaybe<Scalars['Boolean']['input']>;
  wasPaused?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TUpdateGiftEventDataInput = {
  age?: InputMaybe<Scalars['Int']['input']>;
  eventDate: Scalars['AWSDate']['input'];
  groupedToEventId?: InputMaybe<Scalars['ID']['input']>;
  type: TEventTypes;
};

export type TUpdateGiftMutationInput = {
  addressId?: InputMaybe<Scalars['ID']['input']>;
  alerts?: InputMaybe<Array<InputMaybe<TAlertInput>>>;
  eventData?: InputMaybe<Scalars['AWSJSON']['input']>;
  eventDate?: InputMaybe<Scalars['AWSDate']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  rack?: InputMaybe<Scalars['String']['input']>;
  recipientData?: InputMaybe<Scalars['AWSJSON']['input']>;
  referenceEventDate?: InputMaybe<Scalars['AWSDate']['input']>;
  shipmentId?: InputMaybe<Scalars['ID']['input']>;
  shippingDate?: InputMaybe<Scalars['AWSDate']['input']>;
};

export type TUpdateGiftPackageMutationInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  isDefault?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subType?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TGiftPackageType>;
};

export type TUpdateOfficeMutationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<TUpdateAddressMutationInput>;
  contact?: InputMaybe<TUpdateContactMutationInput>;
  legalName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oldSystemId?: InputMaybe<Scalars['Int']['input']>;
};

export type TUpdateProductMutationInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  hsCode?: InputMaybe<Scalars['String']['input']>;
  manufacturerNsProductId?: InputMaybe<Scalars['String']['input']>;
  manufacturerProductId?: InputMaybe<Scalars['String']['input']>;
  manufacturerProductIdType?: InputMaybe<TManufacturerProductIdType>;
  originCriterion?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type TUpdateReferenceEventMutationInput = {
  addressId?: InputMaybe<Scalars['ID']['input']>;
  fullDate?: InputMaybe<Scalars['AWSDate']['input']>;
};

export type TUpdateRosterFileInput = {
  impoortEndedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  importErrors?: InputMaybe<Scalars['AWSJSON']['input']>;
  importStartedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type TUpdateShipmentMutationInput = {
  actualShippingDate?: InputMaybe<Scalars['AWSDate']['input']>;
  addressId?: InputMaybe<Scalars['ID']['input']>;
  addressVerified?: InputMaybe<TShipStationAddressVerified>;
  alerts?: InputMaybe<Array<InputMaybe<TAlertInput>>>;
  isPrintedCUSMA?: InputMaybe<Scalars['Boolean']['input']>;
  isPrintedPhysically?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<TShipmentLabelInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  oldAddressId?: InputMaybe<Scalars['ID']['input']>;
  overrideCarrier?: InputMaybe<Scalars['String']['input']>;
  overrideService?: InputMaybe<Scalars['String']['input']>;
  rack?: InputMaybe<Scalars['String']['input']>;
  shipStationError?: InputMaybe<Scalars['AWSJSON']['input']>;
  shipStationOrderId?: InputMaybe<Scalars['Int']['input']>;
  shipStationShipmentId?: InputMaybe<Scalars['Int']['input']>;
  shippingDate?: InputMaybe<Scalars['AWSDate']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  useGoogleAddress?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TUpdateUserMutationInput = {
  email?: InputMaybe<Scalars['AWSEmail']['input']>;
  googleUserName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TUserType>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type TUser = {
  __typename?: 'User';
  _deleted: Maybe<Scalars['Boolean']['output']>;
  _lastChangedAt: Maybe<Scalars['AWSTimestamp']['output']>;
  _version: Scalars['Int']['output'];
  company: Maybe<TCompany>;
  companyId: Scalars['ID']['output'];
  createdAt: Maybe<Scalars['AWSDateTime']['output']>;
  email: Scalars['AWSEmail']['output'];
  googleUserName: Maybe<Scalars['String']['output']>;
  isCompanyOwner: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  title: Maybe<Scalars['String']['output']>;
  type: TUserType;
  updatedAt: Maybe<Scalars['AWSDateTime']['output']>;
  userId: Maybe<Scalars['String']['output']>;
};

export enum TUserType {
  Admin = 'admin',
  TeamLeader = 'teamLeader'
}

export type TUsersConnection = {
  __typename?: 'UsersConnection';
  items: Array<Maybe<TUser>>;
  nextToken: Maybe<Scalars['String']['output']>;
  scannedCount: Maybe<Scalars['Int']['output']>;
};

export enum TWorkAnniversaryGiftVariations {
  BrickOnly = 'brickOnly',
  Custom = 'custom',
  Deluxe = 'deluxe',
  LegoOnly = 'legoOnly',
  Mini = 'mini'
}

export enum TChildBirthday {
  Child1 = 'child1',
  Child2 = 'child2',
  Child3 = 'child3',
  Child4 = 'child4',
  Child5 = 'child5',
  Child6 = 'child6',
  Child7 = 'child7',
  Child8 = 'child8',
  Child9 = 'child9',
  Child10to14 = 'child10to14',
  Child15to18 = 'child15to18'
}
